import { useRef } from "react";
import { useHitFx } from "./fx";
import { LOADING_COPY } from "./copy";
import { useSlow } from "./hooks";
import { Segments, SlowNotice } from "./HitFullLoader";

// Nivel B · tarjeta "Cargando {sección}" (3c).
export function HitInlineLoader({ section = "catalog", progress = null, onRetry, className = "" }) {
  const copy = LOADING_COPY[section] || LOADING_COPY.catalog;
  const rootRef = useRef(null);
  const stateRef = useRef({});
  stateRef.current = { progress, status: copy.status, steps: [] };
  useHitFx(rootRef, stateRef);
  const slow = useSlow(true);
  return (
    <div className={className}>
      <div ref={rootRef} className="hl-inline sx" role="status" aria-live="polite" data-testid={`hit-inline-loader-${section}`}>
        <span className="sr-only">{`${copy.verb} ${copy.word}`}</span>
        <div className="hl-mini" aria-hidden>
          <svg data-fx="ring" viewBox="0 0 320 320" width="72" height="72" className="hl-mini-ring">
            <circle cx="160" cy="160" r="150" fill="none" stroke="rgba(255,255,255,.14)" strokeWidth="8" />
            <circle cx="160" cy="160" r="150" fill="none" stroke="#FF4438" strokeWidth="14" strokeDasharray="220 740" strokeLinecap="round" />
          </svg>
          <div data-fx="front" className="hl-mini-card"><div data-fx="scan" className="hl-scan hl-scan-sm" /></div>
        </div>
        <div className="hl-inline-body">
          <div data-fx="status" className="hl-mono hl-inline-status">{copy.status}</div>
          <div className="hl-inline-title">{copy.verb} <span className="hl-it">{copy.word}</span></div>
          <Segments className="hl-bar hl-bar-sm" />
        </div>
        <div className="hl-pct hl-inline-pct"><span data-fx="pct" className="hl-mono">··</span><span className="hl-pcts">%</span></div>
      </div>
      {slow && <SlowNotice onRetry={onRetry} testid={`hit-inline-loader-${section}`} />}
    </div>
  );
}
